import React from 'react';
import { useTranslation } from 'react-i18next';
import Overview from 'Components/Overview';

const genOverview = (merchantRules: MerchantRulesData, t: (s: String, config?: any) => string) => [
    {
        label: t('Merchant Status'),
        data: merchantRules?.config?.merchantEnabled ? t('ACTIVE') : t('INACTIVE')
    },
    {
        id: 'rules',
        label: t('Rules'),
        data: merchantRules.rules.length
    },
    {
        id: 'active',
        label: t('Active'),
        data: merchantRules?.rules?.filter((rule) => rule.parameters.active).length
    },
    {
        id: 'overrides',
        label: t('Merchant Overrides'),
        data: merchantRules?.rules?.filter((rule) => rule.inherit === 'MERCHANT').length
    },
    {
        id: 'name',
        label: t('Merchant Name'),
        data: merchantRules?.config?.merchantName
    },
    {
        id: 'description',
        label: t('Description'),
        data: merchantRules?.config?.merchantDescription
    }
];

type Props = {
    merchantRules: MerchantRulesData;
    leftTitle?: string;
};

const MerchantDeployedOverview = ({ merchantRules, leftTitle }: Props) => {
    const { t } = useTranslation();
    const overview = genOverview(merchantRules, t);
    const thresholdConfig = merchantRules.config;
    const threshold = [
        {
            label: t('Merchant-Specific Aggregate Scoring Threshold'),
            data: thresholdConfig?._formatted?.inputDescription
        }
    ];

    return (
        <Overview
            dataTestId='merchant-overview'
            leftTitle={leftTitle ?? t('Merchant Overview')}
            leftData={overview}
            rightData={threshold}
        />
    );
};

export default MerchantDeployedOverview;
